import React from 'react';
import ReactGA from 'react-ga';

let currentUser;

export function setCurrentUser(u) {
    if (typeof u === 'string') {
        u = u.replace('@', '#')
    }
    currentUser = u;
}

export function getCurrentUser(u) {
    return currentUser;
}

export function isTrackingEnabled() {
    return !!Number(window.runConfig.REACT_APP_GA_ENABLED);
}

export function trackPageView(location) {
    if (!isTrackingEnabled()) {
        return;
    }

    location = location || window.location;
    const ga = window.ga;
    if (!ga) {
        return;
    }

    ga('set', 'page', location.pathname)
    ga('set', 'title', document.title)
    ga('send', 'pageview')
}

export const  trackingMiddleware = store => next => action => {
  trackEvent(buildTrackingEvent(action));
  return next(action);
};

const THROTTLE_TIMEOUT = 1500;
const timers = {};

export function trackEvent(event, options) {
    const { throttle } = options || {};
    if (!event) return;
    if (!isTrackingEnabled()) return;

    if (currentUser) {
        event.label = `${event.label} [${currentUser}]`;
    }
    // console.log('trackEvent', event);
    if (!throttle) {
        ReactGA.event(event);
        return;
    }

    const key = `${event.category}-${event.action}`;
    const timer = timers[key];
    if (timer)
        clearTimeout(timer);
    timers[key] = setTimeout(function() { ReactGA.event(event); }, THROTTLE_TIMEOUT);
}

// type is in the formatXXX:YYY, e.gPLACEMENT:SET_EDIT_LIST
// initialize default ga event values
function buildTrackingEvent(action) {
    if (!isTrackingEnabled()) return undefined;
    if (!action) return undefined;
    if (!action.hasOwnProperty('tracking')) return undefined;
    const tracking = action.tracking;
    const type = action.type;
    const { apiCallWorkflow } = action;
    if (apiCallWorkflow === 'request') {
        // ignore API call response because the request has already been tracked
        return undefined;
    }

    if (typeof type !== 'string') return undefined;
    const a = action.type.split(':')
    const evt = {
        category: a[0],
        action: a[1] ? a.slice(1).join(':') : a[0]
    }
    if (typeof tracking === 'object') {
        for(let p of ['category', 'action', 'label', 'value', 'nonInteraction']) {
            if (tracking.hasOwnProperty(p)) {
                if (typeof tracking[p] === 'function') {
                    try {
                        evt[p] = tracking[p](action);
                    } catch(e) {
                        console.log('building tracking event for', action.type, e.message)
                    }
                } else {
                    evt[p] = tracking[p];
                }

            }
        }
    }
    // console.log('track ', evt)
    return evt;

}

export const TrackingCtx = React.createContext();

export function combineEvent(tracking, ctx) {
  ctx = ctx || {}
  tracking = tracking || {}
  const concat = (a, b) => [a, b].filter(x => x).join(' - ');
  return {
    category: concat(ctx.category, tracking.category),
    action: concat(ctx.action, tracking.action),
    label: concat(ctx.label, tracking.label)
  }
}
